module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/font/glyphicons-halflings-regular.ttf
// module id = HI/d
// module chunks = 0